import React from 'react';
import { Box, Typography, Button, Paper } from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';
import BusinessIcon from '@mui/icons-material/Business';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';

const PackageCard = ({ 
  title, 
  price, 
  originalPrice, 
  discount, 
  users, 
  branches, 
  days, 
  isSelected, 
  onSelect,
  isPopular 
}) => {
  return (
    <Paper 
      elevation={3} 
      className={`package-card ${isSelected ? 'selected' : ''}`}
    >

      {/* Good for trial badge */}
      

      {/* Package Title */}
      <Box className="package-title-container">
      <Typography 
        variant="h6" 
        className="package-title"
      >
        {title}
      </Typography>
      <Box className="trial-badge">
      <Typography 
        className="package-sub-title"
      >
        Good for a trial
        </Typography>
      </Box>
      </Box>

      {/* Price Section */}
      <Box className="price-section">
        <Box className="price-row">
          <Typography 
            variant="h4" 
            className="price"
          >
            ${price}
          </Typography>
          {originalPrice && (
            <Typography 
              variant="body2" 
              className="original-price"
            >
              ${originalPrice}
            </Typography>
          )}
                  {discount && (
          <Typography 
            variant="caption" 
            className="discount-badge"
          >
             {discount}% OFF
          </Typography>
        )}
        </Box>

      </Box>

      {/* Features */}
      <Box className="features">
        <Box className="feature-row">
          <PersonIcon className="feature-icon" />
          <Typography variant="body2" className="feature-text">
            {users} Users
          </Typography>
        </Box>

        <Box className="feature-row">
          <BusinessIcon className="feature-icon" />
          <Typography variant="body2" className="feature-text">
            {branches} Branch
          </Typography>
        </Box>

        <Box className="feature-row">
          <CalendarTodayIcon className="feature-icon" />
          <Typography variant="body2" className="feature-text">
            {days} Days
          </Typography>
        </Box>
      </Box>

      {/* Select Button */}
      <Button
        variant={isSelected ? "contained" : "outlined"}
        fullWidth
        onClick={onSelect}
        className={`select-btn ${isSelected ? 'selected' : ''}`}
      >
        {isSelected ? 'Selected' : 'Select'}
      </Button>
    </Paper>
  );
};

export default PackageCard;
